module.exports = __webpack_public_path__ + "static/media/project_config.fc931943.svg";